const render = (component, props) => {
    if (typeof component === 'function') {
        return component(props);
    } else {
        return component;
    }
};

export default render;
